import { normalizeRole } from '@/auth/permissions';

export function canUseEmployeeHome(email?: string | null, role?: string | null, isInternal?: boolean | null): boolean {
  const normalized = (email ?? '').trim().toLowerCase();
  if (!normalized) return false;
  if (isInternal === false) return false;
  if (!role || !role.trim()) return false;
  const normalizedRole = normalizeRole(role);
  return normalizedRole !== 'CLIENTE' &&
    normalizedRole !== 'CONSULTA' &&
    normalizedRole !== 'CONSULTOR_SAI' &&
    normalizedRole !== 'PROVEEDOR';
}
